import angular from 'angular'
import template from './template.html'

export class NominasPendientesCotizarProyectoNominaComponent {
  constructor () {
    this.data = {}
  }
}

angular.module('nominas.pendientes')
  .component('nominasPendientesCotizarProyectoNomina', {
    controller: NominasPendientesCotizarProyectoNominaComponent,
    template: template,
    bindings: {
      data: '<',
      onClose: '&',
    },
  })



// WEBPACK FOOTER //
// ./src/nominas/pendientes/components/cotizar/proyecto/nomina/component.js